import gql from 'graphql-tag';

const MUTATION_RETRY_PAYMENT = gql`
	mutation RetryPayment($id: String!, $type: Int!) {
		retryPayment(id: $id, type: $type)
	}
`;

export default MUTATION_RETRY_PAYMENT;